<template>
    <div>
        <div 
            ref="textContainer" 
            @mouseup="onTextSelection"
            class="text-container h5 lh-lg text-justify"
        >
            <span v-for="(part, index) in textParts" :key="index">
              <span v-if="selectedHighlight">
                  
                  <span :id="part.id" v-if="part.highlight" :class="'item-'+selectedHighlight.index === part.id ? 'highlight-selected': 'text-muted'" >{{ part.text }}</span>
                  <span v-else :class="selectedHighlight && 'text-muted'">{{ part.text }}</span>

              </span>
              <span v-else>
                  <span :id="part.id" v-if="part.highlight" :class="customStyle ? customStyle :'highlight'" :style="customStyle">{{ part.text }}</span>
                  <span v-else>{{ part.text }}</span>
              </span>
            </span>
        </div>

        <!-- Popup de confirmação -->
        <b-modal hide-footer  id="textPopup">

          <div v-if="showPopup && canEdit"  class="p-2 w-100" >
              <div class="mb-3">
                  Deseja marcar <span><b>{{ pendingHighlight.text }}</b></span>?
              </div>
              <b-form @submit.prevent="confirmHighlight" >
  
                <b-form-group
                  label="Título"
                  class="mb-2"
                  >
                  
                  <b-form-input
                      required
                      placeholder="Ex: uso de crase"
                      v-model="pendingHighlight.short_message"
                  />
      
                  
                </b-form-group>
    
                <b-form-group
                  label="Descrição"
                  class="mb-2"
                  >
                  
                  <b-form-input
                      required
                      placeholder="Ex: neste caso aplica-se a regra x"
                      v-model="pendingHighlight.message"
                  />
      
                  
                </b-form-group>
                <b-form-group
                  label="Sugestões"
                  class="mb-2"
                  >
                  <div class="d-flex gap-1 flex-wrap mb-3">
  
                      <span v-for="(replacement, index) in replacements" :key="index"> 
                        <b-badge @click="()=>{ replacements = replacements.filter(item => item.value !== replacement.value)} " pill variant="light" class="cursor-pointer" v-if="replacement" >
                          {{ replacement.value }} x
                        </b-badge>
                      </span>
                  </div>
                  
                  <div class="d-flex gap-1">
  
                    <b-form-input
                        placeholder="Ex: à escola"
                        v-model="sugestion"
                    />
                    <b-button @click="()=>{ if(sugestion) replacements.push({value: sugestion}); sugestion = ''}">adicionar</b-button>
                  </div>
      
                  
                </b-form-group>
                <div class="d-flex pt-3 mb-0 mt-auto gap-1">
    
                    <button type="submit" class="btn btn-primary">Confirmar</button>
                    <button class="btn btn-outline" @click="cancelHighlight">Cancelar</button>
                </div>
              </b-form>
          </div>
        </b-modal>
        
    </div>
  </template>
  
  <script>
  export default {
    name: 'TextHighlight',
    props: {
      text: {
        type: String,
        required: true
      },
      highlights: {
        type: Array,
        default: () => []
      },
      customStyle: {
        type: String,
        default: `
        border-bottom: 2px solid red;
        white-space: inherit;
        `
      },
      activeHighligth :{
        type: String,
        default: `
          background-color: rgba(255, 52, 52, 0.308) !important;
          border-bottom: red solid 2px !important;
          color: black;
        `
      },
      canEdit: {
        type: Boolean,
        default: true,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data() {
    return {
      showPopup: false,
      popupStyle: {
        top: '0px',
        left: '0px'
      },
      pendingHighlight: null,
      selectedHighlight: null,
      replacements: [],
      sugestion: '',
      }
    },
    computed: {
      textParts() {
        const parts = [];
        let lastIndex = 0;

        // Ordena os destaques por posição inicial
        const sortedHighlights = [...this.highlights].sort((a, b) => a.offset - b.offset);

        sortedHighlights.forEach((highlight, index) => {
            if (highlight.offset > lastIndex) {
            parts.push({
                text: this.text.slice(lastIndex, highlight.offset),
                highlight: false
            });
            }

            parts.push({
                text: this.text.slice(highlight.offset, highlight.offset + highlight.length),
                highlight: true,
                id: 'item-'+index
            });

            lastIndex = highlight.offset + highlight.length;
        });

        if (lastIndex < this.text.length) {
            parts.push({
            text: this.text.slice(lastIndex),
            highlight: false
            });
        }

        return parts;
      }
    },
    created (){
      this.$root.$on('collapseItem', ({match, index}) =>{
          console.log(match, index);
          if(this.selectedHighlight && this.selectedHighlight.index === index){
            return this.selectedHighlight = null
          }

          this.selectedHighlight = {...match, index: index};
      }); 
    },
    methods: {
        onTextSelection(event) {
            const selection = window.getSelection();
            const selectedText = selection.toString().trim();
            
            if (selectedText) {
                const range = selection.getRangeAt(0);
                const preSelectionRange = range.cloneRange();
                preSelectionRange.selectNodeContents(this.$refs.textContainer);
                preSelectionRange.setEnd(range.startContainer, range.startOffset);
                const start = preSelectionRange.toString().length;
                
                let hasHighlightInSelection = false

                this.highlights.forEach((highlight, index) =>{
                    if(start >= highlight.offset && start <= highlight.offset+ highlight.length ||
                      start + selectedText.length >= highlight.offset && start +selectedText.length <= highlight.offset+highlight.length ||
                      start < highlight.offset && start + selectedText.length > highlight.offset+highlight.length
                    ){
                      console.log(highlight, index);
                      hasHighlightInSelection = {...highlight, index: index};
                      
                    }
                })

                if( hasHighlightInSelection ){
                  this.$emit('selectedHighlight')
                  this.selectedHighlight = hasHighlightInSelection;
                  this.$root.$emit('bv::toggle::collapse', 'collapse-item-'+hasHighlightInSelection.index)
                  return
                }

                this.selectedHighlight = null
                
                this.pendingHighlight = {
                    start,
                    length: selectedText.length,
                    replacements: []
                };

                // Posiciona o popup próximo à seleção
                this.popupStyle = {
                    top: `${event.clientY + window.scrollY}px`,
                    left: `${event.clientX + window.scrollX}px`
                };
                if(this.canEdit){

                  this.$bvModal.show('textPopup')
                  this.showPopup = true;
                }
            }
        },
        confirmHighlight() {
            if (this.pendingHighlight) {
                
                this.$emit('add-highlight', {...this.pendingHighlight, replacements: this.replacements});
                this.$bvModal.hide('textPopup')

                this.resetSelection();
            }
        },
        cancelHighlight() {
            this.resetSelection();
        },
        resetSelection() {
            this.$bvModal.hide('textPopup')
            this.showPopup = false;
            this.pendingHighlight = null;
            this.selectedHighlight = null;
            this.replacements = []
            window.getSelection().removeAllRanges();

        },
        handleClickOutside(event) {
            if (this.showPopup && !this.$el.contains(event.target)) {
                this.cancelHighlight();
            }
        }
    }
  }
  </script>
  
  <style scoped>
  .text-container {
    user-select: text; /* Permite a seleção de texto */
  }
  .highlight {
    background-color: yellow;
    font-weight: bold;
  }
  .highlight-selected {
    background-color: rgba(255, 52, 52, 0.308) !important;
    border-bottom: red solid 2px !important;
    color: black;
  }
  .popup {
    position: fixed;
    min-width: 200px;
    max-width: 350px;
    min-height: 150px;
    background-color: white;
    border: 1px solid #ccc;
    z-index: 100;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  }

  </style>